export const LogoMark = ({ className = "h-7 w-auto" }) => (
  <img src="/assets/logo-mark.png" alt="TheMapLab" className={className} draggable={false} />
);

export const LogoStacked = ({ className = "h-16 w-auto" }) => (
  <img src="/assets/logo-stacked.png" alt="TheMapLab — ECU Remapping, Car Tuning, Diagnostics" className={className} draggable={false} />
);
